<template>
  <section v-if="orders.length > 0">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition>
          <v-btn
            color="secondary"
            fab
            fixed
            rounded
            dark
            @click="goToOrderPage"
            v-bind="attrs"
            v-on="on"
            height="60"
            width="100"
            bottom
            left
          >
            <span class="font-weight-bold text-wrap text-capitalize">{{
              $translate('ORDER')
            }}</span>
          </v-btn>
        </v-fab-transition>
      </template>
      <span>Order Now</span>
    </v-tooltip>
  </section>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'ProfessionalViewOrderNowBtn',
  computed: {
    ...mapState('shoppingCart', {
      orders: (state) => state.orders,
    }),
  },
  methods: {
    goToOrderPage() {
      this.$router.push({
        name: 'Booking',
      });
    },
  },
};
</script>
